export default __webpack_public_path__ + "static/c2-62ce763be85cfa61633af8f37ee43bec.png";